import useMutation from "src/hooks/useMutation";

function useProviderCreate() {
  return useMutation({
    path: "/api/v1/providers",
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/providers`,
      shouldRevalidate: true,
    },
  });
}

export default useProviderCreate;
